import { module } from 'stereomodularjs';
import LocomotiveScroll from 'locomotive-scroll';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        function onScroll({ direction, scroll }) {
            if (scroll < 50) {
                document.querySelector('html').classList.remove('scrolled-50');
            } else {
                document.querySelector('html').classList.add('scrolled-50');
            }
        }

        window.locomotiveScroll = new LocomotiveScroll({
            lenisOptions: {
                smoothWheel: true, // Set to false to disable smoothScroll, but keep is-inview class triggering
                smoothTouch: false, // Disable on mobile devices
            },
            scrollCallback: onScroll,
        });

        window.locomotiveScroll.scrollTo(0, {
            duration: 0,
            lerp: 0,
        });
    }

    destroy() {
        if (window.locomotiveScroll) {
            window.locomotiveScroll.destroy();
            window.locomotiveScroll = null;
        }
    }
}
